export default __webpack_public_path__ + "static/media/team_willson_zoomed.05ad6bbe.png";